import React from "react";
import { useTranslation } from "react-i18next";

import { NoticeStatus } from "../../../../services/AdminNoticesService";

import style from "./styles.module.scss";

const statusClasses: { [key in NoticeStatus]: string } = {
  draft: style.tagDraft,
  scheduled: style.tagScheduled,
  live: style.tagLive,
  ended: style.tagEnded,
};

interface Props {
  status: NoticeStatus;
}

export default function StatusTag({ status }: Props) {
  const { t } = useTranslation();

  return (
    <span className={`pgm-label-large ${style.tag} ${statusClasses[status]}`}>
      <span aria-hidden="true" className={style.tagDot} />
      {t(`translations.admin.notices.status.${status}`)}
    </span>
  );
}
